<div class="cppOrderSummary">
  <div class="row">
    <div class="prepayContractOuter print-area" id="print-section">
      <div class="prepayContractTop">
        <div class="prepayContract">
          <div class="order-view-sec breadcrumbOuter padding-0 col-md-12">
          </div>
          <div class="row statusNotice m-0">
            <div class="col-md-12">
              <span class="fontCondBold margin-r20">
                Status Notice:
              </span>
              {{statusNotice}}
            </div>
          </div>

          <div class="row contract-info topMargin mx-auto">
            <div class="col-md xs-mb-15 md-mb-0 pl-4">
              <p><span class="w-95">ORDER #: </span><strong><span data-testid="lbl-ordernumb">{{webOrderNumber}}</span></strong></p>
              <p>
                <span class="w-95">CREATED:</span><strong><span>{{shipToAccountdetails.CreatedOn | date:'MM/dd/yyyy'}}</span></strong>
              </p>
              <p>
                <span class="w-95">PLACED BY:</span><strong><span>{{shipToAccountdetails.PlacedByName}}</span></strong>
              </p>
              <p>
                <span class="w-95">
                  CUSTOMER
                  PO#:
                </span><strong><span>{{shipToAccountdetails.CustomerPONumber}}</span></strong>
              </p>
              <p>
                <span class="w-95">
                  Customer Pickup:
                </span><strong><span>{{shipToAccountdetails.CustomerPickUp}}</span></strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0">
              <p>
                <span class="xs-w-95">Associate Location:</span> <strong>
                  <span *ngIf="locationDetails.AccountName">{{locationDetails.AccountName}}</span>
                  <span *ngIf="locationDetails.Address">{{locationDetails.Address}}</span>
                  <span *ngIf="locationDetails.City">{{locationDetails.City}}</span>
                  <span *ngIf="locationDetails.State">{{locationDetails.State}}</span>
                  <span *ngIf="locationDetails.ZipCode">{{locationDetails.ZipCode}}</span>
                  <span *ngIf="locationDetails.ContactName">
                    Name: {{locationDetails.ContactName}}
                  </span>
                  <span *ngIf="locationDetails.Phone"
                        class="display-ib">Phone Number: {{locationDetails.Phone}}</span>
                  <span *ngIf="locationDetails.Email"
                        class="display-ib">Email: {{locationDetails.Email}}</span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0">
              <p>
                <span class="xs-w-95">SHIP TO:</span> <strong>
                  <span>{{shipToAccountdetails.AccountNumber}}</span>
                  <span *ngIf="!shipToAccountdetails.HasMatchAssociate">
                    <span>{{shipToAccountdetails.AccountName}}</span>
                    <span *ngIf="shipToAccountdetails.Address2">{{shipToAccountdetails.Address1}}, {{shipToAccountdetails.Address2}}</span>
                    <span *ngIf="!shipToAccountdetails.Address2">{{shipToAccountdetails.Address1}}</span>
                    <span class="padding-r5">
                      {{shipToAccountdetails.AccountCity}} , {{shipToAccountdetails.AccountState}}
                      <span class="display-ib">{{shipToAccountdetails.AccountZipCode}}</span>

                    </span>
                    <span>Phone:{{shipToAccountdetails.Phone}}</span>
                  </span>
                  <span *ngIf="shipToAccountdetails.HasMatchAssociate">
                    <span>{{shipToAccountdetails.MatchAssociateName}}</span>
                    <span *ngIf="shipToAccountdetails.MatchAddress2">{{shipToAccountdetails.MatchAddress1}}, {{shipToAccountdetails.MatchAddress2}}</span>
                    <span *ngIf="!shipToAccountdetails.MatchAddress2">{{shipToAccountdetails.MatchAddress1}}</span>
                    <span class="padding-r5">
                      {{shipToAccountdetails.MatchCity}} , {{shipToAccountdetails.MatchState}} {{shipToAccountdetails.MatchZipCode}}
                      <span>Name: {{shipToAccountdetails.MatchContactName}}</span>
                      <span>Phone: {{shipToAccountdetails.MatchPhoneNumber}}</span>
                    </span>
                  </span>
                </strong>
              </p>
            </div>

            <div class="col-md xs-mb-15 md-mb-0" *ngIf="deliverToAccountdetails.AccountName">
              <p>
                <span class="xs-w-95">DELIVER TO:</span> <strong>
                  <span *ngIf="deliverToAccountdetails.AccountNumber">{{deliverToAccountdetails.AccountNumber}}</span>
                  <span *ngIf="deliverToAccountdetails.AccountName">{{deliverToAccountdetails.AccountName}}</span>
                  <span *ngIf="deliverToAccountdetails.Address1">{{deliverToAccountdetails.Address1}}</span>
                  <span *ngIf="deliverToAccountdetails.AccountCity">
                    {{deliverToAccountdetails.AccountCity}} , {{deliverToAccountdetails.AccountState}}
                    <span *ngIf="deliverToAccountdetails.AccountZipCode"
                          class="display-ib">{{deliverToAccountdetails.AccountZipCode}}</span>
                  </span>
                </strong>
              </p>
            </div>
          </div>

          <div class="row justify-content-between m-0 pb-3">
            <div class="text-center text-md-left xs-mb-20 md-mb-0 col-md-2 pdfText">
              <span class="md-ml-15 round-icon xs-mr-35 md-mr-15 mobile-round" (click)="generatePdf()">
                <i class="far fa-file-pdf"></i>
              </span>
              View PDF to Print
            </div>
            <div class="col-md-2 d-flex justify-content-end p-0">
              <button mat-raised-button class="btns largeBtn" *ngIf="!readOnlyAccess" (click)="createNewOrder()">Create New Order</button>
            </div>
          </div>
        </div>
      </div>

      <div class="prepayContBottom">
        <div class="prepayContract topMargin">
          <div>
            <div class="OrderReleaseDetail">
              <div class="row">
                <div class="col-md-12 productTableOuter productMargin pl-0">
                  <div>
                    <div>
                      <div class="row m-0 margin-t20 margin-b10 xs-status-row">
                        <div class="col-12">
                          <span><b>Delivery Instructions: {{deliveryInstruction}}</b></span>
                        </div>
                      </div>
                      <div class="row m-0 justify-content-between pb-3">
                        <div class="col-md-3">
                          <span><b>Order ID: {{webOrderNumber}}</b></span>
                        </div>
                        <div class="col-md-3">
                          <span><b>Status: <button class="statusBtn">{{orderStatus}}</button></b></span>
                        </div>
                        <div class="col-md-3">
                          <span class="float-md-right"><b>Requested By Date: {{deliveryDate | date:'MM/dd/yyyy'}} </b></span>
                        </div>
                      </div>
                    </div>
                    <div class="tableContainer summaryPage botMargin table-mobile">
                      <div class="productTableOuter ml-3">
                        <table mat-table [dataSource]="associateOrderSource" multiTemplateDataRows class="matTables productTable">
                          <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                            <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef class="text-center">Marketing Brand</th>
                      </div>
                      <div *ngIf="column=='variety'"><th mat-header-cell *matHeaderCellDef class="text-center">Variety</th></div>
                      <div *ngIf="column=='orderQty'"><th mat-header-cell *matHeaderCellDef class="text-center releaseQuantity">Order Qty</th></div>
                      <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="text-center">UOM</th> </div>
                      <div *ngIf="column=='preferredPackagingSize'"><th mat-header-cell *matHeaderCellDef class="total-units text-center">Preferred Pkg Size</th></div>

                      <td mat-cell *matCellDef="let element">

                        <div *ngIf="column=='marketingBrand'" class="text-center">
                          <div>
                            <p class="m-0">{{element.marketingBrand}}</p>
                          </div>
                        </div>
                        <div *ngIf="column=='variety'" class="text-center">
                          <div>
                            <p class="m-0">{{element.variety}}</p>
                          </div>
                        </div>

                        <div *ngIf="column=='orderQty'" class="text-center">
                          <div>
                            <span> {{element.orderQty}}</span>
                          </div>
                        </div>
                        <div *ngIf="column=='uom'" class="text-center">
                          <div>
                            <span> {{element.uom}}</span>
                          </div>
                        </div>

                        <div *ngIf="column=='preferredPackagingSize'" class="text-center">
                          <div>
                            <span class="geu-txt padding-t2"> {{element.preferredPackagingSize}}</span>
                          </div>
                        </div>
                      </td>
                      </ng-container>


                      <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                      <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="prepayBtnSec footer-action-button">
        <div class="row">
          <div class="col-md-12">
            <button mat-raised-button class="btns xs-button xs-full-width" (click)="backToLandingPage()">Back To View Orders</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
